import React, { useEffect, useRef, useState } from 'react';
import { ProfileService } from '../../common/services/profile.service';
import { Card } from 'azure-devops-ui/Card';
import { UserProfile } from '../../common/clients/ogg';
import { TextField, TextFieldWidth } from 'azure-devops-ui/TextField';
import { FormItem } from 'azure-devops-ui/FormItem';
import { Portal } from 'azure-devops-ui/Portal';
import { FocusZone } from 'azure-devops-ui/FocusZone';
import Loading from '../../common/components/Loading';

export interface IProfileProps {
  profileService: ProfileService;
  portalLeft?: number;
  portalTop?: number;
  close: () => void;
}

export default function Profile(props: IProfileProps) {
  const [userProfile, setUserProfile] = useState({} as UserProfile);
  const ref = useRef(null);

  useEffect(() => {
    async function getData() {
      const profile = await props.profileService.getProfile();
      setUserProfile(profile);
    }

    getData();

    window.addEventListener("click", onWindowClick);

    return function cleanup() {
      window.removeEventListener("click", onWindowClick);
    }
  }, [props.profileService, ref]);

  function onWindowClick(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      props.close();
    }
 }

  return (
    <Portal>
      <div
        className='no-outline portal-surface flex-column'
        role='dialog'
        tabIndex={-1}
        style={{
          left: props.portalLeft,
          top: props.portalTop,
          pointerEvents: 'auto',
        }}
      >
        {(!userProfile.firstName && !userProfile.planName) ? (
          <Loading title='Getting profile info' subtitle='just a sec' />
        ) : (
          <Card
            className='flex-grow'
            titleProps={{ text: `${userProfile.firstName} ${userProfile.lastName}`, ariaLevel: 3 }}
          >
            <div className='flex-column' ref={ref}>
              <FormItem label='Consumed requests:'>
                <TextField
                  value={`${userProfile.consumedRequests.toString()}/${userProfile.requestLimit.toString()}`}
                  width={TextFieldWidth.standard}
                  readOnly
                  disabled
                />
              </FormItem>
            </div>
          </Card>
        )}
      </div>
    </Portal>
  );
}
